<template>
  <div class="ladingBill">
    <vxe-grid
      border
      show-overflow
      resizable
      ref="table"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :max-height="tableHeight"
      :columns="columnList"
      show-footer
      :footer-method="footerMethod"
      column-min-width="120"
    >
    </vxe-grid>
  </div>
</template>
<script>
  import fullScreenDialog from '@/common/mixins/fullScreenDialog.js';
  export default {
    mixins: [fullScreenDialog],
    name: 'ladingBill',
    computed: {
      columnList() {
        return [
          { type: 'seq', title: this.$t('table.index'), width: 60, fixed: 'left' }, // 序号
          {
            field: 'serializationJsonData.externalContractNo',
            title: this.$t('batchAdd.ladingBill.externalContractNo'),
          }, // 外部合同号
          {
            field: 'serializationJsonData.contractNo',
            title: this.$t('batchAdd.ladingBill.contractNo'),
          }, // 合同号
          {
            field: 'serializationJsonData.contractDetailNo',
            title: this.$t('batchAdd.ladingBill.contractDetailNo'),
          }, // 合同商品行项目号
          {
            field: 'serializationJsonData.customerName',
            title: this.$t('batchAdd.ladingBill.customerName'),
          }, // 客户名称
          {
            field: 'serializationJsonData.ladingNo',
            title: this.$t('batchAdd.ladingBill.ladingNo'),
          }, // 提单编号
          {
            field: 'serializationJsonData.ladingDetailNo',
            title: this.$t('batchAdd.ladingBill.ladingDetailNo'),
          }, // 提单明细行项目号
          {
            field: 'serializationJsonData.pickingBusinessInboundBatchNo',
            title: this.$t('batchAdd.ladingBill.pickingBusinessInboundBatchNo'),
          }, // 拣配批次
          {
            field: 'serializationJsonData.ladingCreateDate',
            title: this.$t('batchAdd.ladingBill.ladingCreateDate'),
          }, // 提单日期
          {
            // 提单数量
            field: 'serializationJsonData.ladingQuantity',
            title: this.$t('batchAdd.ladingBill.ladingQuantity'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.serializationJsonData.ladingQuantity,
                      this.$globalVar.qPoint
                    )}
                  </span>,
                ];
              },
            },
          },
          {
            // 拣配数量
            field: 'serializationJsonData.businessPickingQuantity',
            title: this.$t('batchAdd.ladingBill.businessPickingQuantity'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.serializationJsonData.businessPickingQuantity,
                      this.$globalVar.qPoint
                    )}
                  </span>,
                ];
              },
            },
          },
          {
            // 归集数量
            field: 'serializationJsonData.collectionQuantity',
            title: this.$t('batchAdd.ladingBill.collectionQuantity'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.serializationJsonData.collectionQuantity,
                      this.$globalVar.qPoint
                    )}
                  </span>,
                ];
              },
            },
          },
          {
            // 未归集数量
            field: 'serializationJsonData.unCollectionQuantity',
            title: this.$t('batchAdd.ladingBill.unCollectionQuantity'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.serializationJsonData.unCollectionQuantity,
                      this.$globalVar.qPoint
                    )}
                  </span>,
                ];
              },
            },
          },
          {
            // 提单单价
            field: 'serializationJsonData.businessChangingUnitPrice',
            title: this.$t('batchAdd.ladingBill.businessChangingUnitPrice'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.serializationJsonData.businessChangingUnitPrice,
                      this.$globalVar.pPoint
                    )}
                  </span>,
                ];
              },
            },
          },
          {
            // 归集金额
            field: 'serializationJsonData.collectionAmount',
            title: this.$t('batchAdd.ladingBill.collectionAmount'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.serializationJsonData.collectionAmount
                    )}
                  </span>,
                ];
              },
            },
          },
        ];
      },
    },
    data() {
      return {
        tableData: [],
      };
    },
    methods: {
      footerMethod({ columns, data }) {
        let returnProps = [
          'serializationJsonData.businessPickingQuantity',
          'serializationJsonData.collectionQuantity',
          'serializationJsonData.unCollectionQuantity',
          'serializationJsonData.collectionAmount',
        ];
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return this.$t('xTable.total');
            }
            if (returnProps.includes(column.property)) {
              let subtrahend = 0;
              data.map((item) => {
                subtrahend = this.$cal.calCommon(
                  item.serializationJsonData[column.property.replace('serializationJsonData.', '')],
                  subtrahend,
                  '+'
                );
              });
              let point;
              if (column.property.indexOf('Quantity') != -1) {
                point = this.$globalVar.qPoint;
              }
              return this.$baseRequest.formatTableColumn(subtrahend, point);
            }
            return null;
          }),
        ];
      },
    },
  };
</script>
